import axios from "@/plugins/axios";

export default {
    getAsset(link) {
        return axios.httpApi.get(link)
    },
};



